import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';
import { IntakeQuestionnaireItem, QuestionnaireItemGroupType } from 'utils/lib/types/data/paperwork/paperwork.types';
import { RenderItemsProps } from '../../PagedQuestionnaire';
import { usePaperworkOtherColors } from '../../theme';
import MultiAnswerHeader from './MultiAnswerHeader';

interface GroupContainerProps extends Omit<RenderItemsProps, 'items'> {
  pageItem?: IntakeQuestionnaireItem;
  item: IntakeQuestionnaireItem;
  RenderItems: FC<RenderItemsProps>;
}

const baseSX = {
  padding: '8px',
  width: '100%',
  maxWidth: '100%',
  backgroundColor: 'rgba(1,1,1,0)',
  borderRadius: '8px',
};

interface ContentWrapperProps {
  type: 'default' | 'gray-container-widget';
  children: ReactNode;
}

const ContentWrapper: FC<ContentWrapperProps> = ({ type, children }) => {
  const otherColors = usePaperworkOtherColors();

  const sx = (() => {
    let { backgroundColor, padding } = baseSX;
    if (type === 'gray-container-widget') {
      backgroundColor = otherColors.cardBackground;
      padding = '24px';
    }
    return {
      ...baseSX,
      backgroundColor,
      padding,
    };
  })();
  return (
    <Grid id={`group-wrapper-${type}`} container item sx={sx}>
      {children}
    </Grid>
  );
};

const GroupContainer: FC<GroupContainerProps> = ({ item, fieldId, pageItem, parentItem, RenderItems }) => {
  return (
    <ContentWrapper type="default">
      {item.groupType == QuestionnaireItemGroupType.ListWithForm && (
        <>
          <MultiAnswerHeader item={item} parentItem={parentItem} />
          <ContentWrapper type="gray-container-widget">
            <RenderItems items={item.item ?? []} fieldId={item.linkId} parentItem={item} pageItem={pageItem} />
          </ContentWrapper>
        </>
      )}
      {item.groupType != QuestionnaireItemGroupType.ListWithForm && (
        <RenderItems parentItem={item} pageItem={pageItem} items={item.item ?? []} fieldId={fieldId ?? item.linkId} />
      )}
    </ContentWrapper>
  );
};

export default GroupContainer;
